import React from 'react'
import { FeatureGrid, Block } from '@components'

const DatoCmsFeatureGrid = ({
  paddingTop,
  paddingBottom,
  backgroundColour,
  ...props
}) => {
  return (
    <Block
      gutters
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      backgroundColour={backgroundColour}
    >
      <FeatureGrid {...props} />
    </Block>
  )
}

export default DatoCmsFeatureGrid
